module.exports = __webpack_public_path__ + "static/img/JFLOGO.0dab777f.jpg";